import { z } from "zod";

export interface StaffAvailability {
  id: string;
  tenantId: string;
  staffId: string;
  date: Date | string;
  status: "available" | "unavailable" | "not_set";
  notes: string | null;
  createdBy: string | null;
  overriddenBy: string | null;
  createdAt: Date | string | null;
  updatedAt: Date | string | null;
}

export interface LeaveRequest {
  id: string;
  tenantId: string;
  userId: string;
  startDate: Date;
  endDate: Date;
  leaveType: string;
  reason: string | null;
  status: string;
  approvedBy: string | null;
  approvedAt: Date | null;
  createdAt: Date | null;
  updatedAt: Date | null;
}

export const insertLeaveRequestSchema = z.object({
  tenantId: z.string(),
  userId: z.string(),
  startDate: z.coerce.date(),
  endDate: z.coerce.date(),
  leaveType: z.string(),
  reason: z.string().optional(),
  status: z.string().default('pending'),
});

export type InsertLeaveRequest = z.infer<typeof insertLeaveRequestSchema>;

export interface StaffShift {
  id: string;
  tenantId: string;
  userId: string;
  date: Date;
  startTime: string;
  endTime: string;
  shiftType: string | null;
  notes: string | null;
  createdAt: Date | null;
  updatedAt: Date | null;
}

export interface InsertStaffShift {
  tenantId: string;
  userId: string;
  date: Date;
  startTime: string;
  endTime: string;
  shiftType?: string | null;
  notes?: string | null;
}

export interface Timesheet {
  id: string;
  tenantId: string;
  userId: string;
  staffId: string;
  jobId: string | null;
  date: Date;
  startTime: string | null;
  endTime: string | null;
  breakMinutes: number | null;
  hoursWorked: string | null;
  durationHours: string | null;
  notes: string | null;
  status: string | null;
  isApproved: boolean | null;
  isLocked: boolean | null;
  approvedBy: string | null;
  approvedAt: Date | null;
  createdAt: Date | null;
  updatedAt: Date | null;
}

